<template lang='pug'>
  .review-list
    template(v-if='reviewsLoading')
      .product-reviews-loader
        .loader-spinner

    template(v-else)
      template(v-if='reviewsCount === 0')
        template(v-if='isFiltered && !isFilteredByRating')
          p.no-reviews-text(v-text='$t("products.reviews.noReviewsYet")')
        template(v-else)
          .no-filtered-reviews
            p(v-text='$t("products.reviews.noReviewsOnFilter.line1")')
            p(v-text='$t("products.reviews.noReviewsOnFilter.line2")')

      template(v-else)
        .review-item(v-for='review in reviews' :key='review.id')
          product-review(:review='review')
</template>

<script>
import { mapState } from 'vuex'
import ProductReview from './product-review.vue'

export default {
  components: {
    ProductReview
  },

  computed: {
    ...mapState({
      excludeUSReviewsFilter: state => state.review.excludeUSReviewsFilter,
      reviews: state => state.review.reviews,
      reviewsLoading: state => state.review.reviewsLoading,
      reviewsPage: state => state.review.page,
      reviewsCount: state => state.review.count,
      reviewMeta: state => state.review.meta,
      reviewsFilterByVariantIds: state => state.review.filterByVariantIds
    }),
    isFiltered () {
      return this.reviewsFilterByVariantIds.length === 0 && !this.excludeUSReviewsFilter
    },
    isFilteredByRating () {
      return this.reviewMeta['total-ratings'] !== 0 && this.reviewMeta['total'] === 0
    }
  }
}
</script>

<style scoped lang='scss'>
  .product-reviews-loader {
    display: flex;
    justify-content: center;
    min-height: 400px;
    padding-top: 40px;
  }

  .review-list {
    margin-top: 5px;
    margin-bottom: 20px;
  }

  .no-reviews-text {
    margin-top: 70px;
    margin-bottom: 70px;
    text-align: center;
  }

  .review-item {
    border-bottom: 1px solid $grey;

    &:last-child {
      border-bottom: 0;
    }
  }

  .no-filtered-reviews {
    @include font-weight-book;
    font-size: 16px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 150px;
  }
</style>
